export const AUTH_CONFIG = {
  domain: process.env.AUTH_CONFIG_DOMAIN,
  clientId: process.env.AUTH_CONFIG_CLIENT_ID,
  callbackUrl: process.env.AUTH_CONFIG_CALLBACK_URL,
  audience: process.env.AUTH_CONFIG_AUDIENCE
};



// WEBPACK FOOTER //
// ./src/utils/auth/config.tsx